import classes from './campaign-empty-state.module.css';
import Text from '@ui/text/text/text';
import Button from '@ui/buttons/button/button';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import { EColorVariablesV2 } from '@/types/theme-packs.types';

interface CampaignEmptyStateProps {
  onCreate: () => void;
}

const CampaignEmptyState = ({ onCreate }: CampaignEmptyStateProps) => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <Text tag="h3" color={getThemeColorCSSVariable()} className="H3">
          Build your first campaign
        </Text>
        <Text color="var(--global-ico-text-2)" className="S1">
          Customize your campaigns for each specified event
        </Text>
      </div>
      <Button onClick={onCreate} backgroundColor={getThemeColorCSSVariable()} designSize="large">
        <Text
          color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
          className="L1"
        >
          Create Campaign
        </Text>
      </Button>
    </div>
  );
};

export default CampaignEmptyState;
